if (!window.syntraCartUpsellInitialized) {
  window.syntraCartUpsellInitialized = true;

  document.addEventListener('click', async (event) => {
    const addButton = event.target.closest('.upsell-add-btn');
    if (!addButton) return;

    const container = addButton.closest('.cart-drawer-upsell-container');
    const loaderOverlay = container?.querySelector('.upsell-loader-overlay');

    
if (!container || !loaderOverlay || addButton.disabled) return;

event.preventDefault();

const variantId = Number(container.dataset.variantId);

if (!Number.isSafeInteger(variantId) || variantId <= 0) {
  console.error(
    '[Syntra upsell] Invalid variant ID:',
    container.dataset.variantId
  );
  return;
}

    loaderOverlay.classList.remove('visual-hide');
    addButton.disabled = true;

    try {
      const addResponse = await fetch(
        `${window.Shopify.routes.root}cart/add.js`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            items: [
              {
                id: variantId,
                quantity: 1
              }
            ]
          })
        }
      );

      if (!addResponse.ok) {
        throw new Error(`Product could not be added: ${addResponse.status}`);
      }

      let updatedCart = await addResponse.json();
      const discountCode = container.dataset.discountCode?.trim();

      if (discountCode) {
        const discountResponse = await fetch(
          `${window.Shopify.routes.root}cart/update.js`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              discount: discountCode
            })
          }
        );

        if (!discountResponse.ok) {
          throw new Error(
            `Discount could not be applied: ${discountResponse.status}`
          );
        }

        updatedCart = await discountResponse.json();
      }

      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: updatedCart,
            data: {
              source: 'custom-add-to-cart',
              itemCount: updatedCart.item_count
            }
          }
        })
      );
    } catch (error) {
      console.error('[Syntra upsell]', error);
    } finally {
      loaderOverlay.classList.add('visual-hide');
      addButton.disabled = false;
    }
  });
}

(() => {
   
  if (window.__aliaCartGuardInitialized) return;

  window.__aliaCartGuardInitialized = true;

  let isClosingAlia = false;

  const isCartOpen = () =>
    Boolean(document.querySelector('cart-drawer-component dialog[open]'));

  const closeAliaWhileCartIsOpen = () => {
    if (!isCartOpen() || isClosingAlia) return;

    const closeButton = document.querySelector(
      '[id^="alia-root-"][aria-modal="true"] [role="button"][aria-label="Close popup"]'
    );

    if (!closeButton) return;

    isClosingAlia = true;
    closeButton.click();

    window.setTimeout(() => {
      isClosingAlia = false;
    }, 500);
  };

  const startObserver = () => {
    const observer = new MutationObserver(closeAliaWhileCartIsOpen);

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-modal']
    });

    document.addEventListener(
      'toggle',
      closeAliaWhileCartIsOpen,
      true
    );

    closeAliaWhileCartIsOpen();
  };

  if (document.body) {
    startObserver();
  } else {
    document.addEventListener('DOMContentLoaded', startObserver, {
      once: true
    });
  }
})();

(() => {
  if (window.__serlinoSubscriptionCartLockInitialized) return;
  window.__serlinoSubscriptionCartLockInitialized = true;

  const LOCKED_SUBSCRIPTIONS = {
    '55288296767831': 3, // 3 Month
    '55288163729751': 1  // 1 Month
  };

  const getVariantIdFromRow = (row) => {
    const link = row.querySelector('a[href*="variant="]');
    if (!link) return null;

    try {
      const url = new URL(link.href, window.location.origin);
      return url.searchParams.get('variant');
    } catch {
      return null;
    }
  };

  const addTrashButton = (row, quantityComponent) => {
    if (row.querySelector('.serlino-subscription-remove')) return;

    const wrapper =
      quantityComponent.closest('.quantity-selector-wrapper') ||
      quantityComponent.parentElement;

    if (!wrapper) return;

    const trash = document.createElement('button');

    trash.type = 'button';
    trash.className = 'serlino-subscription-remove';
    trash.setAttribute('aria-label', 'Rimuovi dal carrello');
    trash.setAttribute('title', 'Rimuovi dal carrello');

    trash.innerHTML = `
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M4 7h16"
          stroke="currentColor"
          stroke-width="1.8"
          stroke-linecap="round"
        />
        <path d="M9 3h6l1 2H8l1-2Z"
          stroke="currentColor"
          stroke-width="1.8"
          stroke-linejoin="round"
        />
        <path d="M7 7l1 13h8l1-13"
          stroke="currentColor"
          stroke-width="1.8"
          stroke-linejoin="round"
        />
        <path d="M10 11v5M14 11v5"
          stroke="currentColor"
          stroke-width="1.8"
          stroke-linecap="round"
        />
      </svg>
    `;

    wrapper.appendChild(trash);
  };

  const lockSubscriptionRows = () => {
    document
      .querySelectorAll('tr.cart-items__table-row')
      .forEach((row) => {
        const variantId = getVariantIdFromRow(row);

        if (!variantId || !LOCKED_SUBSCRIPTIONS[variantId]) return;

        const quantityComponent =
          row.querySelector('cart-quantity-selector-component');

        if (!quantityComponent) return;

        quantityComponent.style.display = 'none';

        addTrashButton(row, quantityComponent);
      });
  };

  document.addEventListener(
    'click',
    (event) => {
      const trash = event.target.closest('.serlino-subscription-remove');
      if (!trash) return;

      event.preventDefault();

      const row = trash.closest('tr.cart-items__table-row');

      const quantityComponent =
        row?.querySelector('cart-quantity-selector-component');

      const input =
        quantityComponent?.querySelector('input[name="updates[]"]');

      const minusButton =
        quantityComponent?.querySelector('button[name="minus"]');

      if (!input || !minusButton) return;

      input.removeAttribute('readonly');
      input.min = '0';
      input.value = '1';

      minusButton.disabled = false;
      minusButton.click();
    },
    true
  );

  const observer = new MutationObserver(lockSubscriptionRows);

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  lockSubscriptionRows();
})();

(() => {
  if (window.__serlinoCroDirectCheckoutInitialized) return;
  window.__serlinoCroDirectCheckoutInitialized = true;

  const isCroKitPage = () =>
    window.location.pathname.includes('/products/kit-completo-uomo') &&
    new URLSearchParams(window.location.search).get('view') ===
      'cro-kit-completo-sub';

  document.addEventListener(
    'click',
    (event) => {
      if (!isCroKitPage()) return;

      const checkoutButton = event.target.closest(
        '#checkout, button[name="checkout"], .cart__checkout-button'
      );

      if (!checkoutButton) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      window.location.href = `${window.Shopify.routes.root}checkout`;
    },
    true
  );
})();